import { useMutation } from '@tanstack/react-query';

import { SafetyEventClient, SafetyEventReport } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const safetyEventClient = new SafetyEventClient(apiBaseUrl);

function useSaveNewSafetyEvent() {
  return useMutation({
    mutationKey: [queryKeys.SafetyEvent.SaveNew],
    mutationFn: (report: SafetyEventReport) => safetyEventClient.saveNew(report),
  });
}

export default useSaveNewSafetyEvent;
